import React, { Component } from 'react';
import './App.css';
import {
    Link
  } from 'react-router-dom'

export default class Menu extends Component {
    
    render() {
        const listItems = [];
        
        this.props.liste.forEach(periode => {
            
            if(this.props.id_periode == periode.id){
                listItems.push(
                    <div>
                    <Link to={`/periode/${periode.id}`} className="periode_link font-weight-bold ">
                    {periode.annee_debut}-{periode.annee_fin} {periode.libelle}</Link>
                </div>
                );
            }
            else {
                listItems.push(
                    <div>
                    <Link to={`/periode/${periode.id}`} className="periode_link">
                    {periode.annee_debut}-{periode.annee_fin} {periode.libelle}
                    </Link>
                </div>
                );
            }
        }
        );

    var id = Math.floor(Math.random() * (this.props.liste.length))+1;
    return (
    <div>
        <Link to="/"><img src={require('./ressources/signature_white.png')} className="img-fluid" /></Link>
        <br /><br />
        <Link to={`/periode/${id}`} className="btn btn-dark btn-block">Galeries</Link>
        <Link to="/parcours" className="btn btn-dark btn-block">Parcours</Link>
        <Link to="/interview" className="btn btn-dark btn-block">Interview</Link>
        <Link to="/contact" className="btn btn-dark btn-block">Contact</Link>
        <br />
        {listItems}
    </div>

    );
}
}



// WEBPACK FOOTER //
// ./src/Menu.js